const brands = {
    nutrimix: {
        primaryColor: '#943634',
        secondaryColor: '#363494',
        logo: require('@/assets/logo-nutrimix-distribuidora.svg'),
        logoWidth: 150,
        loginLogo: require('@/assets/logo-nutrimix-distribuidora.svg'),
        loginLogoWidth: 280,
        loginTitle: 'Gestor de Projetos',
        title: 'Gestor Nutrimix'
    },
    intereventos: {
        primaryColor: '#224BFB',
        secondaryColor: '#363494',
        logo: require('@/assets/intereventos.png'),
        logoWidth: 40,
        loginLogo: require('@/assets/intereventos.svg'),
        loginLogoWidth: 80,
        loginTitle: 'Gestor de Projetos Intereventos',
        title: 'Gestor Intereventos'
    }
}

const currentBrand = process.env.VUE_APP_BRAND || 'nutrimix'

export default brands[currentBrand]
